module.exports = __webpack_public_path__ + "media/site_templates/www.cheapplumber.net.au/images/splash-f2ea98779e34ef208da8639bee091ac1.jpg";